import _createClass from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { KeyframeTrack } from '../KeyframeTrack.js';
/**
 * A Track of keyframe values that represent color.
 */

var ColorKeyframeTrack = /*#__PURE__*/function (_KeyframeTrack) {
  _inherits(ColorKeyframeTrack, _KeyframeTrack);

  var _super = _createSuper(ColorKeyframeTrack);

  function ColorKeyframeTrack() {
    _classCallCheck(this, ColorKeyframeTrack);

    return _super.apply(this, arguments);
  }

  return _createClass(ColorKeyframeTrack);
}(KeyframeTrack);

ColorKeyframeTrack.prototype.ValueTypeName = 'color'; // ValueBufferType is inherited
// DefaultInterpolation is inherited
// Note: Very basic implementation and nothing special yet.
// However, this is the place for color space parameterization.

export { ColorKeyframeTrack };